import { v4 } from '@rotra-air-ocean/rotranext-shared-code';
import {
  Bot,
  Cloud,
  Cog,
  Flag,
  GitBranch,
  HelpCircle,
  type LucideIcon,
  PenLine,
  Tag,
  Workflow,
  Zap,
} from 'lucide-react';

/** Per-kind icon, label and accent colour shared across the editor and badges. */
export interface KindMeta {
  icon: LucideIcon;
  label: string;
  /** Accent colour used for tints/borders; mirrors the diagram kind colours. */
  color: string;
}

export const KIND_META: Record<v4.StepKind, KindMeta> = {
  auto: { icon: Cog, label: 'Auto service', color: '#10b981' },
  apiCall: { icon: Cloud, label: 'API call', color: '#8b5cf6' },
  outlookCategory: { icon: Tag, label: 'Outlook category', color: '#0ea5e9' },
  userInput: { icon: PenLine, label: 'User input', color: '#3b82f6' },
  llm: { icon: Bot, label: 'AI model', color: '#d946ef' },
  systemOne: { icon: Zap, label: 'System One', color: '#eab308' },
  branch: { icon: GitBranch, label: 'Branch', color: '#f97316' },
  decision: { icon: HelpCircle, label: 'Decision', color: '#f59e0b' },
  subWorkflow: { icon: Workflow, label: 'Sub-workflow', color: '#14b8a6' },
  final: { icon: Flag, label: 'Final', color: '#22c55e' },
};

/** Render the icon for a step kind at a given pixel size. */
export function KindIcon({
  kind,
  size = 16,
}: {
  kind: v4.StepKind;
  size?: number;
}) {
  const Icon = KIND_META[kind].icon;
  return <Icon size={size} aria-hidden />;
}
